import { addNavMenuSection } from "@vendure/admin-ui/core";

export default [
  addNavMenuSection(
    {
      id: "steinmann",
      label: "Steinmann",
      items: [
        {
          id: "dealers",
          label: "Distribuidores",
          routerLink: ["/extensions/dealers"],
          icon: "suitcase",
        },
      ],
    },
    "settings"
  ),
];
